import { ExtendedAxiosResponse, apiClient } from 'helpers/apiClient';

export const api = {
  getUserInfo: (url: string): Promise<ExtendedAxiosResponse> => apiClient.get(`${url}/userInfoProtected`),

  refreshJWTToken: (url: string): Promise<ExtendedAxiosResponse> => apiClient.get(`${url}/refreshJwt`),
};
